export const COUNTERPARTY_EMAIL_PATTERN =
  /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)*$/;

export const isCounterpartyEmailValid = (value = "") =>
  COUNTERPARTY_EMAIL_PATTERN.test(value);